export const formatUnits = (value: number | string): string => {
  return value.toString().replace('m2', 'm\u00B2').replace('m3', 'm\u00B3');
};
